import { Directive, EventEmitter, Input, Output } from '@angular/core';

export interface CampaignTabItem {
  id: string;
  title: string;
  icon: string;
  subItems: string[];
  disabled?: boolean;
  completionPercentage?: number;
  isCompleted?: boolean;
}

/**
 * Base for vertical-tab and horizontal-tab. Shared inputs, outputs, and tab/subItem handlers.
 */
@Directive()
export abstract class CampaignTabBase {
  @Input() tabs: CampaignTabItem[] = [];
  @Input() activeTab = '';
  @Input() sectionCompletionStatus: Record<string, boolean> = {};
  @Output() tabChange = new EventEmitter<string>();
  @Output() subItemClick = new EventEmitter<{ tabId: string; subItem: string }>();

  setActiveTab(tabId: string): void {
    this.activeTab = tabId;
    this.tabChange.emit(tabId);
  }

  onSubItemClick(tabId: string, subItem: string): void {
    this.activeTab = tabId;
    this.subItemClick.emit({ tabId, subItem });
  }

  isSubItemCompleted(subItem: string): boolean {
    return this.sectionCompletionStatus[subItem] || false;
  }
}
